
import React from 'react';

const TestimonialsSection = () => {
  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">Testimonials</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="vintage-card p-6">
          <blockquote className="text-text/90 italic font-lora mb-4">
            "As a New York native, I thought I knew this city. This tour opened my eyes to a whole new layer of history I'd never known about. Seeing my own neighborhood through the lens of its feline past was fascinating!"
          </blockquote>
          <cite className="block text-right font-medium text-primary">— Sarah K., Brooklyn local</cite>
        </div>
        <div className="vintage-card p-6">
          <blockquote className="text-text/90 italic font-lora mb-4">
            "The perfect activity for our weekend visit! Our guide was so knowledgeable and brought these historical cat stories to life. My kids were captivated the entire time - much better than any museum we visited."
          </blockquote>
          <cite className="block text-right font-medium text-primary">— Michael T., Visiting with family from Chicago</cite>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
